module.exports = __webpack_public_path__ + "static/media/icon_dashboard_active.78a4308b.svg";